import { useState, useEffect } from "react";
import { twdClass } from "../../../constants/tailwind.constants";
import FaIcons from "../../common/FaIcons";
import { cloneDeep, findIndex, find } from "lodash";
import { Button, BtnStyle, BtnDelete, BtnBack, BtnAdd, BtnTop, BtnBottom, BtnNext} from "../../ui/com_ui";


export const RspListComponent = ({
  test='',
  items=[],
  title='Elements',
  element_label='Element',
  color='black',
  size='md',
  onRenderItem=()=>{},
  onAdd=()=>{},
  onDelete=()=>{},
  onShuffle=()=>{},
  onUpdate=()=>{},
  onItemStyle=false,
  updateElementValue=()=>{}
}) => {

  
  const addElement = () => {
    const id = new Date().getTime();
    const items2 = [...items, {id }];
    onAdd({items:items2});
  };

  const deletedElement = (id) => {
    const items2 = items.filter((item) => item.id !== id);
    onDelete({items:items2});
  };

  const shuffleElements = (action, id) => {
    const mSections = cloneDeep(items);
    const blockIndex = findIndex(mSections, ["id", id]);
    const record = find(mSections, ["id", id]);
    mSections.splice(blockIndex, 1);
    const moveTo = action === "MOVE_UP" ? blockIndex - 1 : blockIndex + 1;
    mSections.splice(moveTo, 0, record);
    onShuffle({items:mSections});
  };

  const expandElement = (expand, id) => { 
    console.log(expand)   
    const items2 = items.map((item) => {
      if(!item.app) item.app={}
      if(id==item.id) item.app.isExpand=expand
      return item
    });
    onUpdate({items:items2});
  };
  let bgColor='bg-gray-50  border-gray-100  hover:border-gray-200'
  let bColor100='bg-gray-100'
  let bColor300='border-gray-300 hover:border-gray-500'
  if(color=='secondary'){
    bgColor='bg-secondary-200  border-secondary-300  hover:border-secondary-500'
    bColor100='bg-secondary-100'
    bColor300='bg-secondary-100 border-secondary-300 hover:border-secondary-500'
  }else if(color=='primary'){
    bgColor='bg-primary-200  border-primary-300  hover:border-primary-500'
    bColor100='bg-primary-100'
    bColor300='bg-primary-100 border-primary-300 hover:border-primary-500'
  }

  const renderItem = ({item, index}) => {
    const {id, app={}} = item
    const {isExpand=true} = app    
    return(
      <>
        <div className={twdClass(`flex items-center py-1 px-2 gap-2`)}>
          <div className={twdClass("flex items-center gap-1 cursor-pointer")} 
            onClick={() => {expandElement(!isExpand, item.id) }}>
            <div className={twdClass('flex items-center justify-center h-6 w-6')} >
              <FaIcons
                icon={`${isExpand ? "angleUp" : "angleDown"}`}
                className={twdClass("text-sm")}
              />
            </div>
            <div className={twdClass('font-semibold text-sm')} >
              {item.label ? item.label : item.text}
            </div>
          </div>
          <div className={twdClass("flex-grow")}></div>
          {onItemStyle!=false && <BtnStyle              
              onClick={() => onItemStyle({id})}
            > 
            </BtnStyle>}
          <div className={twdClass("flex items-center bg-black bg-opacity-5 px-1 py-1 rounded-full ")}>               
            <BtnTop            
              title="Move Up" size="xs"
              className={'mr-2'}
              onClick={() => shuffleElements("MOVE_UP", item.id)}
            >           
            </BtnTop>
            <BtnBottom            
              title="Move Down" size="xs"
              className={''}
              onClick={() => shuffleElements("MOVE_DOWN", item.id)}
            >           
            </BtnBottom>
          </div>
          <div>              
            <BtnDelete            
              title="Delete" className={"p-2"}
              onClick={() => deletedElement(item.id)}
            >           
            </BtnDelete>
          </div>
        </div>
        <div className={twdClass(` ${isExpand ? "" : "hidden"} px-2 py-2 bg-white border border-gray-100 hover:border-gray-200 rounded-xl`)}>
          { onRenderItem({item, index})}
        </div>   
      </>
    )
  }
  
  return (
    <div className={twdClass(`px-1 py-1 rounded-xl border ${bColor300} mt-4`)}>     
      <div className={twdClass("flex justify-between items-center p-2")}>
        <div className={twdClass("text-sm font-semibold pl-2")}>
          {title}
        </div>        
        <BtnAdd     color={color} size={size}
          onClick={() => addElement()}
        >              
          Add {element_label}
        </BtnAdd>
      </div>
      <div className={twdClass("flex flex-col gap-2")}>
        {items.map((item, index)=>{
          return (
          <div key={index} className={twdClass(`${bgColor}  border  rounded-xl px-1 py-1`)}>
           {renderItem({item, index})}     
          </div>)
        })}
      </div>
    </div>
  );
};
